import axios from 'axios'
import { kebabCase } from 'lodash'

type AWSS3UploadParams = {
  key: string
  policy: string
  xAmzAlgorithm: string
  xAmzCredential: string
  xAmzDate: string
  xAmzSecurityToken: string
  xAmzSignature: string
}

export const uploadDirectToS3 = async (
  url: string,
  file: File | undefined,
  uploadParams: AWSS3UploadParams | undefined,
) => {
  try {
    if (!url || !file || !uploadParams) {
      return { status: null }
    }

    const formData = new FormData()

    // AWS S3 upload expect the POST request to contain these elements in the form data
    // See: https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-authentication-HTTPPOST.html
    Object.entries(uploadParams).forEach(([k, v]) => {
      formData.append(kebabCase(k), v as string)
    })

    formData.append('file', file)

    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response
  } catch (error) {
    return { status: null }
  }
}
